import { inject } from '@angular/core';
import { NavigationService } from 'app/core/navigation/navigation.service';
export const initialDataResolver = () => inject(NavigationService).get();
